<template>
    <b-container>

        <h2><b>Removal of Student Property</b></h2>

        <p>In the event of an emergency or other exigent circumstance, Island Condos and its agents may remove
            students’ belongings from the Premises for cleaning, inspection, repair, storage, and/or protection.
            Island Condos does not assume any obligation or liability for loss or damage to items of personal
            property that may occur during removal of student belongings. Student housing may destroy and discard
            personal belongings such as perishable items, alcohol, illegal drugs and drug-related paraphernalia,
            explosives, and hazardous materials. Should Island Condos discover items that raise concern for
            immediate safety or a significant violation of housing policy or federal law, this matter may be referred to
            the appropriate authorities.</p>

        <h2><b>Abandoned Property</b></h2>

        <p>Any belongings left anywhere in the residence (including common areas) after the residency agreement
            ends or is cancelled are classified as abandoned property. Unsanctioned abandoned property will be
            held for <b><u>14</u></b>
            days. After 14 days, items may be donated to charitable organizations, sold or disposed of.
        </p>

        <h2><b>Commercial Enterprise</b></h2>

        <p>You may not conduct any activity for business or financial gain from a residential facility or any University
            property. Additionally, sales, solicitation, and peddling are strictly prohibited.
        </p>

        <h2><b>Insurance</b></h2>

        <p>Island Condos does not assume any obligation or liability for loss or damage to items of personal
            property which may occur in its buildings or on its grounds, before, during or after the terms of
            residency. This includes but is not limited to damage, loss, fire, water damage, theft, flooding, etc.
            Students are urged to purchase renter's insurance for protection against loss or property damage. We
            encourage you to research options on your own but, if you would like guidance on this issue, please
            contact us at<a href="mailto:studenthousing@bau.edu">studenthousing@bau.edu</a>.
        </p>

        <h2>Resource Guide</h2>

        <p>Linked below is a compressive guide for medical, housing, crisis, etc. resources in DC, MD and VA.
        </p>

        <p><a href="https://example.com/ComprehensiveResourceGuideForDMV.pdf">Resource Guide</a></p>

        <h2><b>Additional Provisions</b></h2>

        <p>Residents are subject to all relevant Island Condos policies, which may be amended or updated from
            time to time in the sole discretion of Island Condos. Student housing retains the unilateral right to
            terminate the residential agreement at any time. Failure of either party to insist upon strict performance
            of any of the Terms or Conditions herein shall not be deemed a waiver of any rights or remedies of either
            party and shall not be deemed a waiver of any subsequent breach or default in any of the Terms or
            Conditions herein. Island Condos assumes no responsibility for failure to perform any terms or
            conditions of this agreement due to any force majeure. For purposes of this agreement, the term "force
            majeure" shall mean fire, earthquake, flood, hurricane, or other significant weather event or natural
            disaster, act of God, strikes, work stoppages or other labor disturbances, riots or civil commotions,
            litigation, war or other act of any foreign nation, plague, epidemic, pandemic, power of government or
            governmental agency or authority, state of emergency, or any other cause like or unlike any cause
            mentioned above, whether natural or man-caused, which is beyond the control or authority of student
            housing. Island Condos does not discriminate in any of its programs, procedures, or practices against any
            person on the basis of age, citizenship, color, disability, national origin, political affiliation, race, religion,
            sex, sexual orientation, gender identity or status as a veteran.</p>

        <div class="mt-4 mb-4">
            <h2 class="text-center text-decoration-underline mb-4"><b>SIGNATURE and ACKNOWLEDGEMENT</b></h2>
            <div>
                <p class="mb-0 text-justify">
                    I hereby certify that I have read and understand the Island Condos Handbook and understand and agree to the terms of this document. The undersigned agrees to pay all the charges arising under the contract and any extensions thereof when due and in accordance with the rules and regulations of Island Condos, together with all fees and other reasonable cost for the collection of any amount not paid when due. The undersigned authorizes student housing to apply any proceeds of any federal and institutional financial aid or registration fee refunds, belonging to the undersigned to any debt, including, fees, interest, room, and/or finance charges, unless prohibited by applicable law. Students will be responsible for all fees and forfeiture outlined in the Terms and Conditions.
                </p>
            </div>

            <div class="p-4">
                <div class="mb-4 d-flex align-items-end">
                    <span class="mr-2 pb-1">Resident printed name:</span>
                    <div class="border-bottom flex-grow-1 position-relative" style="border-color: #000 !important; border-bottom-width: 1px !important; min-height: 25px;">
                        <span class="ml-2 pb-1 d-inline-block">{{ fullName }}</span>
                    </div>
                </div>

                <div class="mb-4 d-flex align-items-end position-relative">
                    <span class="mr-2 pb-1">Resident signature:</span>
                    <div class="border-bottom flex-grow-1 position-relative" style="border-color: #000 !important; border-bottom-width: 1px !important; height: 40px;">
                        <img v-if="form.signature" :src="form.signature" alt="User Signature" style="max-height: 40px; position: absolute; bottom: 0; left: 10px;" />
                    </div>
                </div>
                <div class="d-flex align-items-end w-50">
                    <span class="mr-2 pb-1">{{$t('date')}}:</span>
                    <div class="border-bottom flex-grow-1" style="border-color: #000 !important; border-bottom-width: 1px !important; min-height: 25px;">
                        <span class="ml-2 pb-1 d-inline-block">{{ new Date().toLocaleDateString('en-US') }}</span>
                    </div>
                </div>
            </div>
        </div>

            <SignatureComponent
                v-model="form.signature"
                ref="signatureComponentRef"
            />
        <b-col>
            <ValidationObserver ref="formModalValidate">
                <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
                    <div class="mr-3">
                        <b-form-checkbox
                            id="checkbox-1"
                            v-model="form.status"
                            name="checkbox-1"
                            value="accepted"
                            :unchecked-value="null"
                        >
                            I have read, understood, and accept
                        </b-form-checkbox>
                        <b-form-invalid-feedback v-if="errors[0]"
                                                 v-html="errors[0]">

                        </b-form-invalid-feedback>
                    </div>
                </ValidationProvider>
                <div class="d-flex justify-content-center  align-center mt-3 mb-3">
                    <b-button @click="next" variant="primary" class="mr-3">{{
                            $t('next')
                        }}
                    </b-button>
                </div>
            </ValidationObserver>
        </b-col>


    </b-container>
</template>
<script>
import SignatureComponent from "@/components/elements/Signature.vue";

export default {
    components: {SignatureComponent},

    computed: {
       fullName(){
           const data =this.getWithExpiry('studentInformation',true)
           return data.name + ' ' + data.surname
       }
    },

    data() {
        return {
            form: {
                status:null,
                signature:null
            }
        }
    },
    methods:{
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            const isSignature=await this.$refs.signatureComponentRef.validate()
            if (isValid && isSignature) {
                this.$store.dispatch('housingAgreementForm/saveFormData', this.form)
                this.$emit('next', 1)
            }

        },
    }
}
</script>
<style>
@import ".././Style/Style.css";
</style>
